import { normalize } from 'normalizr'
import { arrayOfOrganizations } from '../../easymsOrganizationSchema'

export default organizations => {
    // we need only ids and names
    const parsedOrganizations = organizations.map(c => ({ id: c.id, name: c.name }))
    return normalize(parsedOrganizations, arrayOfOrganizations)
}



// WEBPACK FOOTER //
// ./src/adapters/parsers/easymsParsers/easymsOrganizations.js